import teamModel from '../../../models/team';

function onTeamUpdated({ data: { updated } }) {
  updated.forEach(update => {
    const { updatedFields } = update;
    if (updatedFields.name) {
      teamModel.changeTeamName(updatedFields.name);
    }
  });
}

export default onTeamUpdated;
